<template>
    <div class="mx-auto">
        <div class="card mt-12">
            <div class="card-header card-header bg-primary text-white h4 m-0">
                <page-title :title="($t(titleKey))"></page-title>
            </div>

            <div class="card-header" v-if="showNewButton || showSettingsBtn">
                <!--Не е позволено създаването на нови динамични регистри-->
                <button type="button" class="btn btn-primary btn-lg"
                        v-if="showNewButton"
                        @click="createBtnClick">
                    {{$t('buttons.create.btnText')}}
                </button>
            </div>

            <div class="card-body">
                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'total'"
                                  :schema-data="'data'"
                                  :page-size='defaultGridRows'
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError"
                                  :requestEnd="datasorceRequestEnd">
                </kendo-datasource>

                <kendo-grid ref="grid"
                            :data-source-ref="'datasource1'"
                            :navigatable="gridOptions.navigatable"
                            :filterable="gridOptions.filterable"
                            :pageable="gridOptions.pageable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            :editable="false"
                            :dataBound="dataBound">
                    <kendo-grid-column :field="'id'"
                                       :filterable="false"
                                       :title="$t('registers.dynamic.gridHeaders.id')"
                                       v-html="rawHtml">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'name'"
                                       :title="$t('registers.dynamic.gridHeaders.name')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'nameEn'"
                                       :title="$t('registers.dynamic.gridHeaders.nameEn')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'active'"
                                       :title="$t('registers.dynamic.gridHeaders.active')"
                                       :template="activeCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :template="btnsTemplate"
                                       field="btnsColumn"
                                       :title="$t('actions')"
                                       v-if="showBtns">
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BtnsTemplate from "../../../components/grid/StandardBtnsTemplate";
    import PageTitle from '../../../components/common/PageTitle';
    import { mapGetters } from 'vuex'

    export default {
        components: {
            PageTitle
        },
        props: {
            showNewButton: {
                default: false,
                type: Boolean
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            showSettingsBtn: {
                default: true,
                type: Boolean
            }
        },
        data() {
            return {
                componentName: "dynamicRegistersList",
                titleKey: 'registers.dynamic.title',
                rawHtml: "",
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                defaultGridRows: this.$store.getters.defaultGridRows,
                working: false,
                customSettingsLoaded: false,
                schemaModelFields: {
                    id: { name: 'id', type: 'number', editable: false, nullable: true, visible: true, titleKey: 'registers.dynamic.gridHeaders.id' },
                    name: { name: 'name', type: 'string', validation: { required: true }, editable: false, nullable: false, visible: true, titleKey: 'registers.dynamic.gridHeaders.name' },
                    nameEn: { name: 'nameEn', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.dynamic.gridHeaders.nameEn' },
                    deactivated: { name: 'deactivated', type: 'boolean', editable: false, nullable: true, visible: false, titleKey: 'registers.dynamic.gridHeaders.deactivated' },
                    active: { name: 'active', type: 'boolean', editable: false, nullable: true, visible: true, titleKey: 'registers.dynamic.gridHeaders.active' }
                },
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/dynamicRegisters/list',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                showUserSettingsForm: false
            }
        },
        methods: {
            dataBound(e) {
                if (!this.customSettingsLoaded) {
                    this.customSettingsLoaded = true;
                    this.loadColumnsVisibilitySettings();
                }
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                })
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    // Викаме POST action за листване на номенклатурите и трябва да сериализираме
                    // options. Така се предава информация за take, skip , page и списък с обекти
                    // описващи сортирането
                    this.saveState();
                    return kendo.stringify(options);
                }
            },
            saveState: function () {
                let grid = this.$refs.grid.kendoWidget();

                localStorage["dynamic-registers-grid-options"] = kendo.stringify(grid.getOptions());
            },
            loadState: function () {
                let options = localStorage["dynamic-registers-grid-options"];
                let grid = this.$refs.grid.kendoWidget();

                if (options) {
                    grid.setOptions(JSON.parse(options));
                }
            },
            activeCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.active ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.active ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.grid,
                        btns: [{
                            name: "edit",
                            text: "",
                            tooltip: this.$t('buttons.edit.btnText'),
                            class: 'btn btn-primary',
                            icon: "fas fa-edit",
                            show: this.hasEditRights,
                            clickHandler: this.editBtnClick
                        }, {
                            name: "deactivation",
                            text: "",
                            tooltip: this.$t('buttons.deactivate.btnText'),
                            class: 'btn btn-danger',
                            icon: "fas fa-lock",
                            show: this.hasDeleteRights,
                            clickHandler: this.deactivateBtnClick
                        }, {
                            name: 'activation',
                            text: "",
                            tooltip: this.$t('buttons.activate.btnText'),
                            class: 'btn btn-success',
                            icon: "fas fa-lock-open",
                            show: this.hasDeleteRights,
                            clickHandler: this.activateBtnClick
                        }]
                    }
                };
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            createBtnClick: function () {
                if (!this.hasCreateRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.$router.push('/dynamic/create');
            },
            editBtnClick: function (args) {
                if (!this.hasEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.$router.push('/dynamic/edit/' + args.id);
            },
            deactivateBtnClick(args) {
                if (!this.hasDeleteRights) {
                    return this.$router.push(`/unauthorized`);
                }

                if (!args.active) {
                    this.$vs.notify({
                        title: this.$t('buttons.deactivate.action'),
                        text: this.$t('buttons.deactivate.already'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration,
                    })

                    return;
                }

                this.working = true;

                this.$http.delete('/api/dynamicRegisters/deactivate',
                    { params: { id: args.id } }
                ).then((response) => {
                    this.$refs.grid.kendoWidget().dataSource.read();

                    this.$vs.notify({
                        title: this.$t('buttons.deactivate.action'),
                        text: response.message ? response.message : (response.request.statusText ? response.request.statusText : response.message),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }).catch(error => {
                    this.$vs.notify({
                        title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                        text: error.response.data.message
                            ? error.response.data.message
                            : (error.response.data
                                ? error.response.data
                                : (error.response.statusText ? error.response.statusText : error.message)),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })

                this.working = false;
            },
            activateBtnClick(args) {
                if (!this.hasDeleteRights) {
                    return this.$router.push(`/unauthorized`);
                }

                if (args.active) {
                    this.$vs.notify({
                        title: this.$t('buttons.activate.action'),
                        text: this.$t('buttons.activate.already'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration,
                    })

                    return;
                }

                this.working = true;

                this.$http.delete('/api/dynamicRegisters/activate',
                    { params: { id: args.id } }
                ).then((response) => {
                    this.$refs.grid.kendoWidget().dataSource.read();

                    this.$vs.notify({
                        title: this.$t('buttons.activate.action'),
                        text: response.message ? response.message : (response.request.statusText ? response.request.statusText : response.message),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }).catch(error => {
                    this.$vs.notify({
                        title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                        text: error.response.data.message
                            ? error.response.data.message
                            : (error.response.data
                                ? error.response.data
                                : (error.response.statusText ? error.response.statusText : error.message)),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })

                this.working = false;
            },
            datasorceRequestEnd(e) {
                if (e.type === "create" && e.response) {
                    // 	console.log(e.response[0]);
                    // alert(e.response[0].TaskID);

                    this.$refs.grid.kendoWidget().dataSource.read();
                    this.$vs.notify({
                        title: '',
                        text: e.response && e.response.message ? e.response.message : this.$t('createSuccess'),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                } else if (e.type === "update" && e.response) {
                    this.$refs.grid.kendoWidget().dataSource.read();
                    this.$vs.notify({
                        title: '',
                        text: e.response && e.response.message ? e.response.message : this.$t('updateSuccess'),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }
            },
            changeGridSettings() {
                this.showUserSettingsForm = !this.showUserSettingsForm;
            },
            gridSettingsChanged(componentName, name, value) {
                this.setColumnVisibilitySettings();
            },
            loadColumnsVisibilitySettings() {
                return this.$http.get('/api/personalization/' + this.componentName + '/getColumnVisibility'
                ).then((response) => {
                    if (response.data.settings === null) {
                        // Липсват запазени каквито и да е потребителски настройки. Осват тези по подразбиране
                        return;
                    }

                    let settings = [];
                    for (var i = 0; i < response.data.settings.length; i++) {
                        settings.push(response.data.settings[i].name)
                    }

                    for (const key in this.schemaModelFields) {
                        if (this.schemaModelFields.hasOwnProperty(key)
                            && this.schemaModelFields[key].hasOwnProperty('visible')) {
                            this.schemaModelFields[key].visible = settings.includes(key);
                        }
                    }

                    this.setColumnVisibilitySettings();
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })
            },
            setColumnVisibilitySettings() {
                var grid = this.$refs.grid.kendoWidget();
                var columns = grid.columns;

                // restore columns visibility state using the stored values
                for (var i = 0; i < columns.length; i++) {
                    var column = columns[i];
                    if (!column.field
                        || !this.schemaModelFields.hasOwnProperty(column.field)
                        || !this.schemaModelFields[column.field].hasOwnProperty('visible')) {
                        continue;
                    }

                    if (this.schemaModelFields[column.field].visible) {
                        grid.showColumn(column);
                    } else {
                        grid.hideColumn(column);
                    }
                }
            },
        },
        mounted: function () {
            var container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({ container });
        },
        computed: {
            ...mapGetters(['gridOptions']),
            token: function () {
                return this.$store.getters.authToken;
            },
            hasCreateRights() {
                return this.$store.getters.claims.dynamicRegister.create;
            },
            hasEditRights() {
                return this.$store.getters.claims.dynamicRegister.create
                    || this.$store.getters.claims.dynamicRegister.update;
            },
            hasDeleteRights() {
                return this.$store.getters.claims.dynamicRegister.delete;
            },
        }
    }
</script>

<style scoped>
</style>
